import { cn } from '@elara/client-core/lib/utils';

import { AppImage } from '#ui/AppImage.js';
import { SimpleMarkdown } from '#ui/chat/SimpleMarkdown.js';

interface AdvisorNoteProps {
  text: string;
  className?: string;
}

export function AdvisorNote({ text, className }: AdvisorNoteProps) {
  return (
    <div className={cn('flex flex-col gap-3 rounded-sm border bg-background-secondary p-3 text-sm', className)}>
      <SimpleMarkdown text={text} className="italic max-w-prose" />
      <div className="flex items-center gap-2">
        <AppImage src="/team/shannon.jpg" alt="Shannon" width="24" height="24" className="rounded-full" />
        <div className="space-y-0">
          <div className="text-2xs font-medium leading-4">Shannon</div>
          <div className="text-2xs text-muted-foreground leading-4">Travel advisor</div>
        </div>
      </div>
    </div>
  );
}
